<template>
  <router-link :to="{ name: 'points', params: { tourId: $route.params.tourId }, query: { ...$route.query } } ">
    <img 
      v-if="headerLogo" 
      class="block h-14 w-auto" 
      :src="headerLogo" 
      :alt="tourSettings?.name"
    />
    <svg 
      v-else
      width="38" 
      height="38" 
      viewBox="0 0 990 988" 
      version="1.1"
      xmlns="http://www.w3.org/2000/svg" 
      :style="{
        color: 'black',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: '2'
      }"
    >
      <path
        d="M296.782,208.964c-30.388,30.368 -52.839,66.558 -66.381,106.032c-9.942,25.677 -14.958,55.838 -14.958,90.327c0,53.193 13.975,109.858 41.52,168.391c21.508,45.679 51.345,92.726 88.685,139.812c63.057,79.519 125.415,131.562 128.041,133.745l19.442,16.118l19.442,-16.118c2.636,-2.183 64.985,-54.226 128.051,-133.745c37.34,-47.086 67.177,-94.133 88.675,-139.812c27.555,-58.533 41.539,-115.198 41.539,-168.391c0,-74.179 -28.892,-143.913 -81.348,-196.359c-52.446,-52.456 -122.18,-81.339 -196.359,-81.339c-74.169,0 -143.903,28.883 -196.349,81.339Zm196.349,-20.426c119.544,0 216.785,97.25 216.785,216.785c-0,34.823 -7.376,69.665 -19.482,103.426c-0.167,-44.234 -9.883,-80.837 -20.681,-107.92c-22.088,-55.396 -60.421,-103.417 -110.831,-138.869c-47.244,-33.21 -100.024,-51.501 -148.624,-51.501c-4.258,-0 -8.438,0.088 -12.539,0.226c28.795,-14.171 61.179,-22.147 95.372,-22.147Zm91.458,293.914c-31.184,-58.405 -79.5,-111.018 -136.066,-148.171c-42.041,-27.615 -84.239,-43.251 -120.793,-45.385c20.563,-11.614 48.237,-17.524 82.568,-17.524c69.931,-0 164.939,56.861 202.869,152.016c19.885,49.869 21.822,103.643 5.792,159.875c-5.251,-33.86 -16.787,-67.876 -34.37,-100.811Zm-308.233,-77.129c0,-47.017 21.655,-52.436 28.755,-54.216c25.943,-6.49 68.082,6.569 109.976,34.085c47.479,31.194 89.688,77.1 115.758,125.947c24.94,46.722 34.862,95.381 28.706,140.717c-6.097,44.795 -27.545,87.278 -63.853,126.644c-1.18,1.21 -2.341,2.41 -3.531,3.629c-57.392,-53.311 -215.811,-215.142 -215.811,-376.806Z"
        :style="{
          fill: 'currentColor',
          stroke: 'currentColor',
          strokeWidth: '3.13px'
        }"
      />
      <path
        d="M961.083,139.981c0,-61.735 -50.121,-111.856 -111.855,-111.856l-709.247,0c-61.735,0 -111.856,50.121 -111.856,111.856l0,707.962c0,61.735 50.121,111.856 111.856,111.856l709.247,-0c61.734,-0 111.855,-50.121 111.855,-111.856l0,-707.962Z"
        :style="{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: '56.25px',
          strokeLinecap: 'round',
          strokeMiterlimit: '1.5'
        }"
      />
    </svg>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'VueLogo',
  setup() {
    const route = useRoute()
    const headerLogo = ref(null)
    
    return {
      headerLogo,
      route
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings']),
  },
  watch: {
    tourSettings: {
      handler(newSettings) {
        if (newSettings?.header_logo) {
          this.headerLogo = newSettings.header_logo.preview_url
        }
      },
      immediate: true
    }
  }
}
</script> 